<template>
  <!-- Side panel used for adding and editing on the asset pages, so the page stays visible behind it (US 9370) -->
  <b-modal ref="panel"
           :modal-class="['v2-panel', { 'v2-panel--wide': wide }]"
           hide-header
           hide-footer
           :no-close-on-backdrop="busy"
           @hidden="$emit('hidden')"
  >
    <div class="v2-panel__inner" :qid="qid">
      <header class="v2-panel__head">
        <div class="v2-panel__row">
          <span v-if="kind" class="v2-panel__kind">{{ kind }}</span>
          <h2 class="v2-panel__title">{{ title }}</h2>
          <button type="button"
                  class="v2-panel__close"
                  :aria-label="$t('system_hero.panel.close')"
                  @click="hide">
            <font-awesome-icon icon="times"/>
          </button>
        </div>
        <p v-if="intro" class="v2-panel__intro">{{ intro }}</p>
        <slot name="head"></slot>
      </header>

      <div class="v2-panel__body">
        <slot></slot>
      </div>

      <footer v-if="$slots.foot" class="v2-panel__foot">
        <slot name="foot"></slot>
      </footer>
    </div>
  </b-modal>
</template>

<script>
  export default {
    name: 'V2SidePanel',
    props: {
      title: { type: String, required: true },
      kind: { type: String, default: '' },
      intro: { type: String, default: '' },
      // While saving, a click outside the panel doesn't close it
      busy: { type: Boolean, default: false },
      // For panels with a lot side by side, e.g. adding a risk scenario
      wide: { type: Boolean, default: false },
      qid: { type: String, default: 'side-panel' }
    },
    methods: {
      show() {
        this.$refs.panel.show();
      },
      hide() {
        this.$refs.panel.hide();
      }
    }
  }
</script>
